// A18.23 compliance-status dashboard — module-local data layer. READ-ONLY
// aggregate over the compliance subsystems (GDPR/legal-holds/takedowns/emergency/
// consents/legal-docs). No table of its own.
import { api } from '@/lib/api'

export interface ComplianceSummary {
  gdpr: { open: number; overdue: number; total: number }
  legal_holds: { active: number; total: number }
  takedowns: { open: number; total: number }
  emergency: { pending: number; critical: number; total: number }
  consents: { total: number }
  legal_docs: { published_kinds: number; versions: number }
  processors: { active: number; no_dpa: number; total: number }
}

export const fetchSummary = (s?: AbortSignal) =>
  api.get<ComplianceSummary>('/admin/compliance/summary', s ? { signal: s } : undefined)

export const CO_STR = {
  title: 'Compliance-статус',
  desc: 'Сводка по подсистемам соответствия (только чтение)',
  gdpr: 'GDPR / DSAR',
  legalHolds: 'Legal holds',
  takedowns: 'Удаление контента',
  emergency: 'Экстренные запросы',
  consents: 'Согласия',
  legalDocs: 'Юр. документы',
  processors: 'Обработчики данных (Art.30)',
  noDpa: 'Без DPA',
  open: 'Открыто',
  overdue: 'Просрочено',
  active: 'Активно',
  pending: 'В ожидании',
  critical: 'Критично',
  total: 'Всего',
  versions: 'Версий',
  published: 'Опубликовано',
  view: 'Открыть',
  attention: 'Требует внимания',
  allClear: 'Всё в порядке',
} as const
